import { type NodeViewProps } from '@tiptap/core'
import _ from 'lodash'

export const handleInputName = (name: string, props: NodeViewProps) => {
	props.updateAttributes({ name: _.camelCase(name) })
	props.updateAttributes({ placeholder: name })
	console.log('name', name)
}
